<div *ngIf="org$ | async as org">
  <mode-empty-report-header></mode-empty-report-header>
  <mode-data-import-tiles [org]="org.username"></mode-data-import-tiles>
</div>
